/** @fileoverview @suppress {undefinedVars} */

import * as exports from '../generators/php.js';
$['__chunk_php'] = exports;
